import { singleton } from "tsyringe";
import { RouteLocationNormalized } from "vue-router";

@singleton()
export class NavigationService {
    /**
     * @description 만일 현재의 route.path 가 props.path 와 같다면, refetchTrigger 내 navigatePath 를 적용시킵니다.
     * 경로 비교 시 기본 경로만 비교합니다.
     */
    public conditionallyApplyRefetchTrigger = (route: RouteLocationNormalized, path: string) => {
        const currentNavigatePath = path;
        const currentPath = route.path;

        // 경로의 기본 부분만 추출 (첫 번째 슬래시 이후부터 다음 슬래시나 끝까지)
        const baseNavigatePath = currentNavigatePath.split("/")[1] || "";
        const baseCurrentPath = currentPath.split("/")[1] || "";

        if (baseNavigatePath === baseCurrentPath) {
            return "routerPush";
        } else {
            return "resetPath";
        }
    };
}
